export default __webpack_public_path__ + "static/media/supreme.88a94e8a.png";